import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

import { track } from "../track";
import { buildOfferAnalyticsBaseParams } from "./offerAnalyticsParams";

interface Params {
  offerKey: OnboardingOfferKey;
}

export const trackOfferPopupExit = ({ offerKey }: Params) =>
  track({ event: "offer_popup_exit", ...buildOfferAnalyticsBaseParams(offerKey) });
